import React from 'react';
import reportIconSvg from './report.svg';

const ReportIcon = () => {
  return (
    <img
      src={reportIconSvg}
      alt="Reports Icon"
      style={{ width: '137px', height: '136px' }}
    />
  );
};

export default ReportIcon;
